import { DataCollection, DataEvents, DragEvents, IDataEventsHandlersMap, IDragEventsHandlersMap, IDragConfig } from "@dhx/ts-data";
import { IEventSystem } from "@dhx/ts-common/events";
import { ISelection } from "@dhx/ts-list";

export interface IDataViewConfig extends IDragConfig {
	data?: DataCollection<any> | any[];
	itemsInRow?: number;
	height?: number | string;
	itemHeight?: number | string;
	gap?: number;
	template?: (item: any) => string;
	keyNavigation?: boolean | (() => boolean);
	css?: string;
	multiselection?: boolean;
	multiselectionMode?: "click" | "ctrlClick";
	editing?: boolean;
}

export interface IDataView<T = any> {
	config: IDataViewConfig;
	data: DataCollection<T>;
	events: IEventSystem<DataEvents | DragEvents | DataViewEvents, IDataEventsHandlersMap & IDragEventsHandlersMap & IDataViewEventHandlersMap>;
	selection: ISelection;
	paint(): void;
	edit(id: string): void;
	getFocusItem(): T;
	destructor(): void;
	setFocus(id: string): void;
	getFocus(): string;

	// TODO: remove sute_7.0
	getFocusIndex(): number;
	setFocusIndex(index: number): void;
}

export enum DataViewEvents {
	click = "click",
	doubleClick = "doubleclick",
	contextmenu = "contextmenu",
	focusChange = "focuschange",
	beforeEditStart = "beforeEditStart",
	afterEditStart = "afterEditStart",
	beforeEditEnd = "beforeEditEnd",
	afterEditEnd = "afterEditEnd"
}

export interface IDataViewEventHandlersMap {
	[key: string]: (...args: any[]) => any;
	[DataViewEvents.click]: (id: string, e: Event) => any;
	[DataViewEvents.doubleClick]: (id: string, e: Event) => any;
	[DataViewEvents.contextmenu]: (id: string, e: MouseEvent) => any;
	[DataViewEvents.focusChange]: (focusIndex: number, id: string) => any;
	[DataViewEvents.beforeEditStart]: (id: string) => void | boolean;
	[DataViewEvents.afterEditStart]: (id: string) => void;
	[DataViewEvents.beforeEditEnd]: (value: any, id: string) => void | boolean;
	[DataViewEvents.afterEditEnd]: (value: any, id: string) => void;
}

export interface IDataViewItem {
	[key:string]:any;
}